import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import {
  Expense,
  ExpenseRequest,
  ExpenseSearchParams,
} from "@/interfaces/expense";
import {
  expenses,
  summary_expenses,
  clubUUID,
  paginationLinks,
} from "@/shared/state";
import { useModal } from "@/composables/modal/useModal";
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useExpense() {
  const isRequestExpense = ref<boolean | false>(false);
  const errorExpense = ref<boolean | false>(false);
  const { closeModal } = useModal();
  const getExpenses = async (body: ExpenseSearchParams) => {
    try {
      isRequestExpense.value = true;
      errorExpense.value = false;
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}expenses/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      if (response) {
        //  expenses.data = response?.data?.expenses || [];
        if (body?.type === "paginate") {
          summary_expenses.data = response?.summary[0] || {};
          expenses.data = response?.expenses?.data || [];
          paginationLinks.value = response?.expenses || [];
          delete paginationLinks.value.data;
        } else if (body?.type === "all") {
          if (response?.summary) {
            summary_expenses.data = response?.summary || {};
            expenses.data = response?.expenses || {};
          } else {
            expenses.data = response || {};
          }
        }
      }
      isRequestExpense.value = false;
    } catch (err: any) {
      isRequestExpense.value = false;
      errorExpense.value = true;
    }
  };

  const addExpense = async (body: ExpenseRequest) => {
    try {
      isRequestExpense.value = true;
      errorExpense.value = false;
      const response = await authenticatedFetch(
        `${API_URL}expenses/store`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response?.data) {
        const expenseAdded: Expense = response?.data;
        expenses?.data?.unshift(expenseAdded);
        closeModal("modal_add_expense", "add");
        isRequestExpense.value = false;
      }
      isRequestExpense.value = false;
    } catch (err: any) {
      errorExpense.value = true;
      isRequestExpense.value = false;
    }
  };

  const editExpense = async (body: ExpenseRequest) => {
    try {
      isRequestExpense.value = true;
      errorExpense.value = false;
      const response = await authenticatedFetch(
        `${API_URL}expenses/edit/${body?.id}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        const expenseEdited: Expense = response?.data;
        const index = expenses?.data?.findIndex(
          (expense) => expense?.id === expenseEdited?.id,
        );
        if (index !== -1) {
          expenses.data[index] = expenseEdited;
        }
        isRequestExpense.value = false;
      }
      isRequestExpense.value = false;
    } catch (err: any) {
      isRequestExpense.value = false;
      errorExpense.value = true;
    }
  };

  const deleteExpense = async (id: number) => {
    try {
      isRequestExpense.value = true;
      errorExpense.value = false;
      const response = await authenticatedFetch(
        `${API_URL}expenses/delete/${id}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      const index = expenses?.data?.findIndex((expense) => expense?.id === id);
      if (index !== -1) {
        expenses.data.splice(index, 1);
      }
      isRequestExpense.value = false;
    } catch (err: any) {
      errorExpense.value = true;
      isRequestExpense.value = false;
    }
  };

  return {
    getExpenses,
    addExpense,
    editExpense,
    deleteExpense,
    isRequestExpense,
    errorExpense,
  };
}
